import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-layout-download',
  templateUrl: './layout-download.component.html',
  styleUrls: ['./layout-download.component.scss']
})
export class LayoutDownloadComponent implements OnInit {
  isLoading = true;

  constructor() {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.isLoading = false;
    }, 2500);
  }

}
